import {createEvent, createStore} from "effector";

export const setAddress = createEvent()
export const addressStore = createStore("https://tkpoluslab.ru:8081/")
    .on(setAddress, (state, value) => value)